/**
 * Heartbeat Manager
 * Extracted from WebSocketManager.ts
 * Manages periodic ping messages to maintain connection
 */

export class HeartbeatManager {
  private heartbeatTimer: NodeJS.Timeout | null = null;
  private heartbeatInterval: number;

  constructor(heartbeatInterval: number = 30000) {
    this.heartbeatInterval = heartbeatInterval;
  }

  // Start sending periodic heartbeat
  start(sendPingFn: () => void): void {
    // Clear any existing heartbeat timer
    this.stop();

    // Send ping at specified interval
    this.heartbeatTimer = setInterval(() => {
      sendPingFn();
    }, this.heartbeatInterval);
  }

  // Stop heartbeat
  stop(): void {
    if (this.heartbeatTimer) {
      clearInterval(this.heartbeatTimer);
      this.heartbeatTimer = null;
    }
  }

  // Check if heartbeat is active
  isActive(): boolean {
    return this.heartbeatTimer !== null;
  }
}
